module.exports = __webpack_public_path__ + "static/media/payrexx-logo.7dca715d.png";